import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2fd0d623 = () => interopDefault(import('..\\pages\\about.vue' /* webpackChunkName: "pages/about" */))
const _9b5f34ea = () => interopDefault(import('..\\pages\\articles\\index.vue' /* webpackChunkName: "pages/articles/index" */))
const _1ecd8552 = () => interopDefault(import('..\\pages\\aup.vue' /* webpackChunkName: "pages/aup" */))
const _5adfea57 = () => interopDefault(import('..\\pages\\careers\\index.vue' /* webpackChunkName: "pages/careers/index" */))
const _fd1ea494 = () => interopDefault(import('..\\pages\\contact.vue' /* webpackChunkName: "pages/contact" */))
const _6cf1b2f5 = () => interopDefault(import('..\\pages\\disclaimer.vue' /* webpackChunkName: "pages/disclaimer" */))
const _1c64f9cd = () => interopDefault(import('..\\pages\\docs\\index.vue' /* webpackChunkName: "pages/docs/index" */))
const _4f88b0e8 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _784eb374 = () => interopDefault(import('..\\pages\\game-design-tool.vue' /* webpackChunkName: "pages/game-design-tool" */))
const _873ba952 = () => interopDefault(import('..\\pages\\games.vue' /* webpackChunkName: "pages/games" */))
const _5944e70a = () => interopDefault(import('..\\pages\\glossary\\index.vue' /* webpackChunkName: "pages/glossary/index" */))
const _42d0ade8 = () => interopDefault(import('..\\pages\\learn\\index.vue' /* webpackChunkName: "pages/learn/index" */))
const _6f749e78 = () => interopDefault(import('..\\pages\\liveops-whitepaper.vue' /* webpackChunkName: "pages/liveops-whitepaper" */))
const _e4dd6b46 = () => interopDefault(import('..\\pages\\partners\\index.vue' /* webpackChunkName: "pages/partners/index" */))
const _fe6062b4 = () => interopDefault(import('..\\pages\\pricing\\index.vue' /* webpackChunkName: "pages/pricing/index" */))
const _11421e2b = () => interopDefault(import('..\\pages\\search-results.vue' /* webpackChunkName: "pages/search-results" */))
const _dd07be18 = () => interopDefault(import('..\\pages\\terms-and-conditions\\index.vue' /* webpackChunkName: "pages/terms-and-conditions/index" */))
const _ae31ddb8 = () => interopDefault(import('..\\pages\\community\\explore.vue' /* webpackChunkName: "pages/community/explore" */))
const _63ae1490 = () => interopDefault(import('..\\pages\\community\\see-all.vue' /* webpackChunkName: "pages/community/see-all" */))
const _1bf9193d = () => interopDefault(import('..\\pages\\docs\\search.vue' /* webpackChunkName: "pages/docs/search" */))
const _7ed41a2e = () => interopDefault(import('..\\pages\\resources\\academic-research-publications.vue' /* webpackChunkName: "pages/resources/academic-research-publications" */))
const _06f4f99f = () => interopDefault(import('..\\pages\\articles\\author\\_slugAuthor\\index.vue' /* webpackChunkName: "pages/articles/author/_slugAuthor/index" */))
const _6f296e3f = () => interopDefault(import('..\\pages\\articles\\category\\_slugCategory\\index.vue' /* webpackChunkName: "pages/articles/category/_slugCategory/index" */))
const _becbda3e = () => interopDefault(import('..\\pages\\articles\\page\\_pageNumber.vue' /* webpackChunkName: "pages/articles/page/_pageNumber" */))
const _4849c44b = () => interopDefault(import('..\\pages\\careers\\job\\_jobSlug.vue' /* webpackChunkName: "pages/careers/job/_jobSlug" */))
const _fd85ae16 = () => interopDefault(import('..\\pages\\articles\\author\\_slugAuthor\\page\\_pageNumber.vue' /* webpackChunkName: "pages/articles/author/_slugAuthor/page/_pageNumber" */))
const _a770a4d6 = () => interopDefault(import('..\\pages\\articles\\category\\_slugCategory\\page\\_pageNumber.vue' /* webpackChunkName: "pages/articles/category/_slugCategory/page/_pageNumber" */))
const _3e36b8fa = () => interopDefault(import('..\\pages\\articles\\_slugPost.vue' /* webpackChunkName: "pages/articles/_slugPost" */))
const _4d0ea919 = () => interopDefault(import('..\\pages\\docs\\_docSlug.vue' /* webpackChunkName: "pages/docs/_docSlug" */))
const _578e45c2 = () => interopDefault(import('..\\pages\\glossary\\_slug.vue' /* webpackChunkName: "pages/glossary/_slug" */))
const _2e78436a = () => interopDefault(import('..\\pages\\learn\\_learnSlug.vue' /* webpackChunkName: "pages/learn/_learnSlug" */))
const _95c2b6f6 = () => interopDefault(import('..\\pages\\community\\_communityUser\\profile.vue' /* webpackChunkName: "pages/community/_communityUser/profile" */))
const _1e45bcdc = () => interopDefault(import('..\\pages\\community\\_communityUser\\_userAction.vue' /* webpackChunkName: "pages/community/_communityUser/_userAction" */))
const _4dd20fa0 = () => interopDefault(import('..\\pages\\_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _2fd0d623,
    pathToRegexpOptions: {"strict":true},
    name: "about___en___default"
  }, {
    path: "/articles",
    component: _9b5f34ea,
    pathToRegexpOptions: {"strict":true},
    name: "articles___en___default"
  }, {
    path: "/aup",
    component: _1ecd8552,
    pathToRegexpOptions: {"strict":true},
    name: "aup___en___default"
  }, {
    path: "/careers",
    component: _5adfea57,
    pathToRegexpOptions: {"strict":true},
    name: "careers___en___default"
  }, {
    path: "/contact",
    component: _fd1ea494,
    pathToRegexpOptions: {"strict":true},
    name: "contact___en___default"
  }, {
    path: "/disclaimer",
    component: _6cf1b2f5,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___en___default"
  }, {
    path: "/docs",
    component: _1c64f9cd,
    pathToRegexpOptions: {"strict":true},
    name: "docs___en___default"
  }, {
    path: "/en",
    component: _4f88b0e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/game-design-tool",
    component: _784eb374,
    pathToRegexpOptions: {"strict":true},
    name: "game-design-tool___en___default"
  }, {
    path: "/games",
    component: _873ba952,
    pathToRegexpOptions: {"strict":true},
    name: "games___en___default"
  }, {
    path: "/glossary",
    component: _5944e70a,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___en___default"
  }, {
    path: "/learn",
    component: _42d0ade8,
    pathToRegexpOptions: {"strict":true},
    name: "learn___en___default"
  }, {
    path: "/liveops-whitepaper",
    component: _6f749e78,
    pathToRegexpOptions: {"strict":true},
    name: "liveops-whitepaper___en___default"
  }, {
    path: "/partners",
    component: _e4dd6b46,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en___default"
  }, {
    path: "/pricing",
    component: _fe6062b4,
    pathToRegexpOptions: {"strict":true},
    name: "pricing___en___default"
  }, {
    path: "/search-results",
    component: _11421e2b,
    pathToRegexpOptions: {"strict":true},
    name: "search-results___en___default"
  }, {
    path: "/terms-and-conditions",
    component: _dd07be18,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___en___default"
  }, {
    path: "/community/explore",
    component: _ae31ddb8,
    pathToRegexpOptions: {"strict":true},
    name: "community-explore___en___default"
  }, {
    path: "/community/see-all",
    component: _63ae1490,
    pathToRegexpOptions: {"strict":true},
    name: "community-see-all___en___default"
  }, {
    path: "/docs/search",
    component: _1bf9193d,
    pathToRegexpOptions: {"strict":true},
    name: "docs-search___en___default"
  }, {
    path: "/en/about",
    component: _2fd0d623,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/articles",
    component: _9b5f34ea,
    pathToRegexpOptions: {"strict":true},
    name: "articles___en"
  }, {
    path: "/en/aup",
    component: _1ecd8552,
    pathToRegexpOptions: {"strict":true},
    name: "aup___en"
  }, {
    path: "/en/careers",
    component: _5adfea57,
    pathToRegexpOptions: {"strict":true},
    name: "careers___en"
  }, {
    path: "/en/contact",
    component: _fd1ea494,
    pathToRegexpOptions: {"strict":true},
    name: "contact___en"
  }, {
    path: "/en/disclaimer",
    component: _6cf1b2f5,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___en"
  }, {
    path: "/en/docs",
    component: _1c64f9cd,
    pathToRegexpOptions: {"strict":true},
    name: "docs___en"
  }, {
    path: "/en/game-design-tool",
    component: _784eb374,
    pathToRegexpOptions: {"strict":true},
    name: "game-design-tool___en"
  }, {
    path: "/en/games",
    component: _873ba952,
    pathToRegexpOptions: {"strict":true},
    name: "games___en"
  }, {
    path: "/en/glossary",
    component: _5944e70a,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___en"
  }, {
    path: "/en/learn",
    component: _42d0ade8,
    pathToRegexpOptions: {"strict":true},
    name: "learn___en"
  }, {
    path: "/en/liveops-whitepaper",
    component: _6f749e78,
    pathToRegexpOptions: {"strict":true},
    name: "liveops-whitepaper___en"
  }, {
    path: "/en/partners",
    component: _e4dd6b46,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en"
  }, {
    path: "/en/pricing",
    component: _fe6062b4,
    pathToRegexpOptions: {"strict":true},
    name: "pricing___en"
  }, {
    path: "/en/search-results",
    component: _11421e2b,
    pathToRegexpOptions: {"strict":true},
    name: "search-results___en"
  }, {
    path: "/en/terms-and-conditions",
    component: _dd07be18,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___en"
  }, {
    path: "/resources/academic-research-publications",
    component: _7ed41a2e,
    pathToRegexpOptions: {"strict":true},
    name: "resources-academic-research-publications___en___default"
  }, {
    path: "/en/community/explore",
    component: _ae31ddb8,
    pathToRegexpOptions: {"strict":true},
    name: "community-explore___en"
  }, {
    path: "/en/community/see-all",
    component: _63ae1490,
    pathToRegexpOptions: {"strict":true},
    name: "community-see-all___en"
  }, {
    path: "/en/docs/search",
    component: _1bf9193d,
    pathToRegexpOptions: {"strict":true},
    name: "docs-search___en"
  }, {
    path: "/en/resources/academic-research-publications",
    component: _7ed41a2e,
    pathToRegexpOptions: {"strict":true},
    name: "resources-academic-research-publications___en"
  }, {
    path: "/en/articles/author/:slugAuthor",
    component: _06f4f99f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor___en"
  }, {
    path: "/en/articles/category/:slugCategory",
    component: _6f296e3f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory___en"
  }, {
    path: "/en/articles/page/:pageNumber?",
    component: _becbda3e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-page-pageNumber___en"
  }, {
    path: "/en/careers/job/:jobSlug?",
    component: _4849c44b,
    pathToRegexpOptions: {"strict":true},
    name: "careers-job-jobSlug___en"
  }, {
    path: "/en/articles/author/:slugAuthor?/page/:pageNumber?",
    component: _fd85ae16,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor-page-pageNumber___en"
  }, {
    path: "/en/articles/category/:slugCategory?/page/:pageNumber?",
    component: _a770a4d6,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory-page-pageNumber___en"
  }, {
    path: "/articles/author/:slugAuthor",
    component: _06f4f99f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor___en___default"
  }, {
    path: "/articles/category/:slugCategory",
    component: _6f296e3f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory___en___default"
  }, {
    path: "/articles/page/:pageNumber?",
    component: _becbda3e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-page-pageNumber___en___default"
  }, {
    path: "/careers/job/:jobSlug?",
    component: _4849c44b,
    pathToRegexpOptions: {"strict":true},
    name: "careers-job-jobSlug___en___default"
  }, {
    path: "/en/articles/:slugPost",
    component: _3e36b8fa,
    pathToRegexpOptions: {"strict":true},
    name: "articles-slugPost___en"
  }, {
    path: "/en/docs/:docSlug",
    component: _4d0ea919,
    pathToRegexpOptions: {"strict":true},
    name: "docs-docSlug___en"
  }, {
    path: "/en/glossary/:slug",
    component: _578e45c2,
    pathToRegexpOptions: {"strict":true},
    name: "glossary-slug___en"
  }, {
    path: "/en/learn/:learnSlug",
    component: _2e78436a,
    pathToRegexpOptions: {"strict":true},
    name: "learn-learnSlug___en"
  }, {
    path: "/en/community/:communityUser?/profile",
    component: _95c2b6f6,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-profile___en"
  }, {
    path: "/articles/author/:slugAuthor?/page/:pageNumber?",
    component: _fd85ae16,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor-page-pageNumber___en___default"
  }, {
    path: "/articles/category/:slugCategory?/page/:pageNumber?",
    component: _a770a4d6,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory-page-pageNumber___en___default"
  }, {
    path: "/en/community/:communityUser?/:userAction?",
    component: _1e45bcdc,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-userAction___en"
  }, {
    path: "/articles/:slugPost",
    component: _3e36b8fa,
    pathToRegexpOptions: {"strict":true},
    name: "articles-slugPost___en___default"
  }, {
    path: "/docs/:docSlug",
    component: _4d0ea919,
    pathToRegexpOptions: {"strict":true},
    name: "docs-docSlug___en___default"
  }, {
    path: "/en/:slug",
    component: _4dd20fa0,
    pathToRegexpOptions: {"strict":true},
    name: "slug___en"
  }, {
    path: "/glossary/:slug",
    component: _578e45c2,
    pathToRegexpOptions: {"strict":true},
    name: "glossary-slug___en___default"
  }, {
    path: "/learn/:learnSlug",
    component: _2e78436a,
    pathToRegexpOptions: {"strict":true},
    name: "learn-learnSlug___en___default"
  }, {
    path: "/community/:communityUser?/profile",
    component: _95c2b6f6,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-profile___en___default"
  }, {
    path: "/community/:communityUser?/:userAction?",
    component: _1e45bcdc,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-userAction___en___default"
  }, {
    path: "/",
    component: _4f88b0e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___en___default"
  }, {
    path: "/:slug",
    component: _4dd20fa0,
    pathToRegexpOptions: {"strict":true},
    name: "slug___en___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
